import { mapToCanActivate, mapToResolve, Routes } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { CreateFeedAdviceComponent } from './components/create-feed-advice/create-feed-advice.component';
import { CreateFeedAdviceFromReferenceComponent } from './components/create-feed-advice-from-reference/create-feed-advice-from-reference.component';
import { FeedAdviceOverviewComponent } from './components/feed-advice-overview/feed-advice-overview.component';
import { FeedAdvice } from './models/feed-advice.model';
import { FeedAdviceOverviewResolver } from './resolvers/feed-advice-overview.resolver';
import { GetFeedAdviceByIdResolver } from './resolvers/get-feed-advice-by-id.resolver';

export const FeedAdviceRoutes = (): Routes => [
  {
    path: '',
    component: FeedAdviceOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'create-from-reference',
    component: CreateFeedAdviceFromReferenceComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'create',
    component: CreateFeedAdviceComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'edit/:id',
    component: CreateFeedAdviceComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      feedadvice: mapToResolve<Observable<FeedAdvice>>(GetFeedAdviceByIdResolver),
    },
  },
  {
    path: 'view/:id',
    component: CreateFeedAdviceComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      feedadvice: mapToResolve<Observable<FeedAdvice>>(GetFeedAdviceByIdResolver),
    },
  },
];
